import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChatComponent } from './chat.component';
import { ChatService } from './chat.service';
import { GroupListComponent } from './group-list/group-list.component';
import { ChannelListComponent } from './channel-list/channel-list.component';
import { ChatPanelComponent } from './chat-panel/chat-panel.component';
import { metaReducers } from './ngrx/metaReducers';
import { reducers } from './ngrx/reducers';
import { ChatEffects } from './ngrx/effects';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StoreModule.forFeature(ChatService.featureName, reducers, { metaReducers }),
    EffectsModule.forFeature([ChatEffects])
  ],
  declarations: [
    ChatComponent,
    GroupListComponent,
    ChannelListComponent,
    ChatPanelComponent
  ],
  exports: [
    ChatComponent
  ],
  providers: [
    ChatService
  ]
})
export class ChatModule {
}

export * from './chat.service';
